import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum Form1099NecColumn {
    DATE = "date",
    SOURCE = "source",
    REFERENCE = "reference",
    DESCRIPTION = "description",
    FORM_1099_BOX = "form1099Box",
    ACCOUNT = "account",
    SPLIT = "split",
    AMOUNT = "amount",
    BALANCE = "balance",
}

const makeColumnSchema = (id: Form1099NecColumn) =>
    ColumnSchema.extend({ id: z.literal(id) });

export const Form1099NecViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.FORM_1099_NEC),
    columns: z.array(
        z.discriminatedUnion("id", [
            makeColumnSchema(Form1099NecColumn.DATE),
            makeColumnSchema(Form1099NecColumn.SOURCE),
            makeColumnSchema(Form1099NecColumn.REFERENCE),
            makeColumnSchema(Form1099NecColumn.DESCRIPTION),
            makeColumnSchema(Form1099NecColumn.FORM_1099_BOX),
            makeColumnSchema(Form1099NecColumn.ACCOUNT),
            makeColumnSchema(Form1099NecColumn.SPLIT),
            makeColumnSchema(Form1099NecColumn.AMOUNT),
            makeColumnSchema(Form1099NecColumn.BALANCE),
        ]),
    ),
});

export type Form1099NecView = z.infer<typeof Form1099NecViewSchema>;
